/* CVF-049-AB */
(function () {
  'use strict';

  var VISIBLE_CLASS = 'is-visible';
  var MARK_ATTR = 'data-cvf-049-ab';

  var DEFAULTS = {
    fitmentMessage: 'Fitment confirmed for your vehicle',
    freeShipping: 'Free Shipping',
    lifetimeWarranty: 'Lifetime Warranty',
    dayReturns: '30-Day Returns',
    subtotalLabel: 'Subtotal (__COUNT__ item)',
    subtotalLabelPlural: 'Subtotal (__COUNT__ items)',
    shippingLabel: 'Shipping',
    shippingValue: 'FREE',
    secureCheckout: 'Secure Checkout · __AMOUNT__',
    encryptedMessage: 'Encrypted and secure checkout',
    installmentsPrefix: 'As low as',
    installmentsSuffix: 'with',
    continueShopping: 'Continue shopping',
    shopPayLogoUrl: '',
  };

  var cachedCart = null;
  var cartObserverStarted = false;
  var applying = false;

  function debounce(func, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  function getConfig() {
    var node = document.getElementById('cvf-049-ab-config');
    if (!node) return DEFAULTS;
    try {
      return Object.assign({}, DEFAULTS, JSON.parse(node.textContent));
    } catch (error) {
      return DEFAULTS;
    }
  }

  function cloneIcon(templateId) {
    var template = document.getElementById(templateId);
    if (!template || !template.content) return null;
    var source = template.content.querySelector('svg');
    if (!source) return null;
    var icon = source.cloneNode(true);
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    return icon;
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function replaceToken(template, token, value) {
    return String(template || '').split(token).join(String(value));
  }

  function getCartRoot() {
    return document.querySelector('.upcart-cart');
  }

  function getCartHeader(cartRoot) {
    return cartRoot.querySelector('.upcart-header, .upcart-public-header');
  }

  function getProductsSection(cartRoot) {
    return (
      cartRoot.querySelector('.upcart-products-section') ||
      cartRoot.querySelector('.upcart-public-cart-items') ||
      cartRoot.querySelector('[class*="upcart-public-cart-items"]')
    );
  }

  function getFooter(cartRoot) {
    return cartRoot.querySelector('.upcart-footer');
  }

  function getCheckoutButton(cartRoot) {
    return cartRoot.querySelector('.upcart-checkout-button');
  }

  function getContinueLink(cartRoot) {
    return cartRoot.querySelector('.upcart-continue-shopping');
  }

  function getExpressPay(cartRoot) {
    return (
      cartRoot.querySelector('#upcart-express-pay-buttons-container') ||
      cartRoot.querySelector('[class*="ExpressPayButtonsModule_expressPayButtonsContainer"]')
    );
  }

  async function fetchCart() {
    try {
      var response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  function updateCartCloseIcon(cartRoot) {
    var header = getCartHeader(cartRoot);
    if (!header) return;

    var closeBtn = header.querySelector(
      '.upcart-header-close-button, .upcart-public-header__close-button'
    );
    if (!closeBtn || closeBtn.querySelector('[data-cvf-049-ab-close]')) return;

    var icon = cloneIcon('cvf-049-ab-icon-close');
    if (!icon) return;

    icon.setAttribute('data-cvf-049-ab-close', 'true');
    icon.classList.add('upcart-header-close-button-icon', 'cvf-049-ab__close-icon');
    closeBtn.innerHTML = '';
    closeBtn.appendChild(icon);
  }

  function ensureTrustBadges(cartRoot, config) {
    var header = getCartHeader(cartRoot);
    if (!header) return;

    var existing = cartRoot.querySelector('.cvf-049-ab__trust');
    if (existing) {
      if (existing.previousElementSibling !== header) {
        header.insertAdjacentElement('afterend', existing);
      }
      var shippingIcon = existing.querySelector('.cvf-049-ab__trust-item .cvf-049-ab__trust-icon');
      if (shippingIcon) {
        shippingIcon.classList.add('cvf-049-ab__trust-icon--shipping');
      }
      var items = existing.querySelectorAll('.cvf-049-ab__trust-item');
      if (items[0]) items[0].classList.add('cvf-049-ab__trust-item--shipping');
      if (items[1]) items[1].classList.add('cvf-049-ab__trust-item--warranty');
      if (items[2]) items[2].classList.add('cvf-049-ab__trust-item--returns');
      return;
    }

    var trust = document.createElement('div');
    trust.className = 'cvf-049-ab__trust';
    trust.setAttribute(MARK_ATTR, 'true');
    trust.setAttribute('role', 'list');

    var items = [
      {
        label: config.freeShipping,
        templateId: 'cvf-049-ab-icon-shipping',
        iconClass: 'cvf-049-ab__trust-icon--shipping',
        itemClass: 'cvf-049-ab__trust-item--shipping',
      },
      {
        label: config.lifetimeWarranty,
        templateId: 'cvf-049-ab-icon-warranty',
        iconClass: '',
        itemClass: 'cvf-049-ab__trust-item--warranty',
      },
      {
        label: config.dayReturns,
        templateId: 'cvf-049-ab-icon-returns',
        iconClass: '',
        itemClass: 'cvf-049-ab__trust-item--returns',
      },
    ];

    items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'cvf-049-ab__trust-item ' + item.itemClass;
      row.setAttribute('role', 'listitem');

      var iconWrap = document.createElement('span');
      iconWrap.className = 'cvf-049-ab__trust-icon' + (item.iconClass ? ' ' + item.iconClass : '');
      var icon = cloneIcon(item.templateId);
      if (icon) iconWrap.appendChild(icon);

      var label = document.createElement('p');
      label.className = 'cvf-049-ab__trust-label';
      label.textContent = item.label;

      row.appendChild(iconWrap);
      row.appendChild(label);
      trust.appendChild(row);
    });

    header.insertAdjacentElement('afterend', trust);
  }

  function ensureFitmentBanner(cartRoot, config, hasItems) {
    var products = getProductsSection(cartRoot);
    var banner = cartRoot.querySelector('.cvf-049-ab__fitment');

    if (!banner) {
      banner = document.createElement('div');
      banner.className = 'cvf-049-ab__fitment';
      banner.setAttribute(MARK_ATTR, 'true');
      banner.setAttribute('role', 'status');

      var iconWrap = document.createElement('span');
      iconWrap.className = 'cvf-049-ab__fitment-icon';
      iconWrap.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.0251 6.6414C15.2692 6.88548 15.2692 7.28121 15.0251 7.52529L9.19178 13.3586C8.9477 13.6027 8.55197 13.6027 8.3079 13.3586L4.97456 10.0253C4.73048 9.78121 4.73048 9.38548 4.97456 9.1414C5.21864 8.89732 5.61437 8.89732 5.85845 9.1414L8.74984 12.0328L14.1412 6.6414C14.3853 6.39732 14.781 6.39732 15.0251 6.6414Z" fill="#279157"/></svg>';

      var text = document.createElement('p');
      text.className = 'cvf-049-ab__fitment-text';
      text.textContent = config.fitmentMessage;

      banner.appendChild(iconWrap);
      banner.appendChild(text);
    } else {
      var textNode = banner.querySelector('.cvf-049-ab__fitment-text');
      if (textNode) textNode.textContent = config.fitmentMessage;
    }

    if (products && products.parentNode) {
      if (banner.previousElementSibling !== products) {
        products.insertAdjacentElement('afterend', banner);
      }
    }

    if (hasItems) {
      banner.classList.add(VISIBLE_CLASS);
    } else {
      banner.classList.remove(VISIBLE_CLASS);
    }
  }

  function getShopPayInstallmentsCta() {
    var termsList = document.querySelectorAll('shopify-payment-terms');
    for (var i = 0; i < termsList.length; i++) {
      var terms = termsList[i];
      var root = terms.shadowRoot;
      if (!root) continue;
      var cta = root.querySelector(
        '#shopify-installments-cta, [data-testid="shopify-installments-cta"], button'
      );
      if (cta) return cta;
    }
    return null;
  }

  function getShopPayMonthlyLabel(fallbackCents) {
    var terms = document.querySelector('shopify-payment-terms');
    if (terms && terms.shadowRoot) {
      var content = terms.shadowRoot.querySelector(
        '#shopify-installments-content, [data-testid="shopify-installments-content"]'
      );
      if (content) {
        var bold = content.querySelector('.font-bold, strong, b');
        if (bold && bold.textContent) {
          var cleaned = bold.textContent.trim();
          if (cleaned) return cleaned.replace(/\s*\/\s*mo$/i, '') + '/mo';
        }
        var match = content.textContent.match(/\$[\d,]+(?:\.\d{2})?\s*\/\s*mo/i);
        if (match) return match[0].replace(/\s+/g, '');
      }
    }
    return formatMoney(fallbackCents) + '/mo';
  }

  function openShopPayInstallments() {
    var cta = getShopPayInstallmentsCta();
    if (cta) {
      try {
        cta.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      } catch (error) {
        cta.click();
      }
      return true;
    }

    var learnMore = document.querySelector(
      '.shopify-installments__learn-more, a[href*="shop-pay"], a[href*="shop_pay"]'
    );
    if (learnMore) {
      learnMore.click();
      return true;
    }

    return false;
  }

  function onInstallmentsActivate(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var block = target.closest('.cvf-049-ab__installments');
    if (!block) return;

    event.preventDefault();
    event.stopPropagation();
    openShopPayInstallments();
  }

  document.addEventListener('click', onInstallmentsActivate, true);
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      onInstallmentsActivate(event);
    },
    true
  );

  function ensureInstallments(cartRoot, config, cart) {
    var fitment = cartRoot.querySelector('.cvf-049-ab__fitment');
    var block = cartRoot.querySelector('.cvf-049-ab__installments');
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var hasItems = cart && cart.item_count > 0;

    if (block && (block.tagName === 'BUTTON' || block.tagName === 'A')) {
      var next = document.createElement('div');
      next.className = block.className;
      next.innerHTML = block.innerHTML;
      Array.prototype.forEach.call(block.attributes, function (attr) {
        if (attr.name === 'type' || attr.name === 'href') return;
        next.setAttribute(attr.name, attr.value);
      });
      block.parentNode.replaceChild(next, block);
      block = next;
    }

    if (!block) {
      block = document.createElement('div');
      block.className = 'cvf-049-ab__installments';
      block.setAttribute(MARK_ATTR, 'true');
      block.setAttribute('role', 'button');
      block.setAttribute('tabindex', '0');
      block.setAttribute('aria-label', 'View Shop Pay installment plans');

      var text = document.createElement('span');
      text.className = 'cvf-049-ab__installments-text';

      var prefix = document.createElement('span');
      prefix.className = 'cvf-049-ab__installments-prefix';

      var amount = document.createElement('span');
      amount.className = 'cvf-049-ab__installments-amount';

      var suffix = document.createElement('span');
      suffix.className = 'cvf-049-ab__installments-suffix';

      text.appendChild(prefix);
      text.appendChild(document.createTextNode(' '));
      text.appendChild(amount);
      text.appendChild(document.createTextNode(' '));
      text.appendChild(suffix);
      block.appendChild(text);

      if (config.shopPayLogoUrl) {
        var logo = document.createElement('img');
        logo.className = 'cvf-049-ab__installments-logo';
        logo.src = config.shopPayLogoUrl;
        logo.alt = '';
        logo.width = 57;
        logo.height = 22;
        logo.loading = 'lazy';
        block.appendChild(logo);
      }
    } else {
      block.setAttribute('role', 'button');
      block.setAttribute('tabindex', '0');
      block.setAttribute('aria-label', 'View Shop Pay installment plans');
    }

    var monthlyCents = Math.max(100, Math.round(total / 11));
    var prefixNode = block.querySelector('.cvf-049-ab__installments-prefix');
    var amountNode = block.querySelector('.cvf-049-ab__installments-amount');
    var suffixNode = block.querySelector('.cvf-049-ab__installments-suffix');

    if (prefixNode) prefixNode.textContent = config.installmentsPrefix;
    if (amountNode) amountNode.textContent = getShopPayMonthlyLabel(monthlyCents);
    if (suffixNode) suffixNode.textContent = config.installmentsSuffix;

    if (fitment && fitment.parentNode) {
      if (block.previousElementSibling !== fitment) {
        fitment.insertAdjacentElement('afterend', block);
      }
    }

    if (hasItems && total > 0) {
      block.classList.add(VISIBLE_CLASS);
    } else {
      block.classList.remove(VISIBLE_CLASS);
    }
  }

  function ensureSummary(footer, config, cart) {
    var summary = footer.querySelector('.cvf-049-ab__summary');
    var checkoutWrap =
      footer.querySelector('.styles_Footer__checkoutButton__') ||
      footer.querySelector('.upcart-checkout-button-container');

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'cvf-049-ab__summary';
      summary.setAttribute(MARK_ATTR, 'true');

      var subtotalRow = document.createElement('div');
      subtotalRow.className = 'cvf-049-ab__summary-row';
      var subtotalLabel = document.createElement('span');
      subtotalLabel.className = 'cvf-049-ab__summary-subtotal-label';
      var subtotalValue = document.createElement('span');
      subtotalValue.className = 'cvf-049-ab__summary-subtotal-value';
      subtotalRow.appendChild(subtotalLabel);
      subtotalRow.appendChild(subtotalValue);

      var shippingRow = document.createElement('div');
      shippingRow.className = 'cvf-049-ab__summary-row';
      var shippingLabel = document.createElement('span');
      shippingLabel.className = 'cvf-049-ab__summary-shipping-label';
      var shippingValue = document.createElement('span');
      shippingValue.className = 'cvf-049-ab__summary-shipping';
      shippingRow.appendChild(shippingLabel);
      shippingRow.appendChild(shippingValue);

      summary.appendChild(subtotalRow);
      summary.appendChild(shippingRow);
    }

    var count = cart && cart.item_count ? cart.item_count : 0;
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var labelTemplate = count === 1 ? config.subtotalLabel : config.subtotalLabelPlural;

    var subtotalLabelNode = summary.querySelector('.cvf-049-ab__summary-subtotal-label');
    var subtotalValueNode = summary.querySelector('.cvf-049-ab__summary-subtotal-value');
    var shippingLabelNode = summary.querySelector('.cvf-049-ab__summary-shipping-label');
    var shippingValueNode = summary.querySelector('.cvf-049-ab__summary-shipping');

    if (subtotalLabelNode) subtotalLabelNode.textContent = replaceToken(labelTemplate, '__COUNT__', count);
    if (subtotalValueNode) subtotalValueNode.textContent = formatMoney(total);
    if (shippingLabelNode) shippingLabelNode.textContent = config.shippingLabel;
    if (shippingValueNode) shippingValueNode.textContent = config.shippingValue;

    if (checkoutWrap && checkoutWrap.parentNode) {
      if (summary.nextElementSibling !== checkoutWrap) {
        checkoutWrap.parentNode.insertBefore(summary, checkoutWrap);
      }
    } else if (!summary.parentNode) {
      footer.insertBefore(summary, footer.firstChild);
    }

    if (count > 0) {
      summary.classList.add(VISIBLE_CLASS);
    } else {
      summary.classList.remove(VISIBLE_CLASS);
    }
  }

  function updateCheckoutButton(cartRoot, config, cart) {
    var button = getCheckoutButton(cartRoot);
    if (!button) return;

    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var label = replaceToken(config.secureCheckout, '__AMOUNT__', formatMoney(total));
    var existingLabel = button.querySelector('.cvf-049-ab__checkout-label');

    if (button.getAttribute(MARK_ATTR) === 'true' && existingLabel && existingLabel.textContent === label) {
      return;
    }

    button.setAttribute(MARK_ATTR, 'true');
    button.textContent = '';

    var lockWrap = document.createElement('span');
    lockWrap.className = 'cvf-049-ab__checkout-lock';
    var lockIcon = cloneIcon('cvf-049-ab-icon-lock');
    if (lockIcon) {
      lockWrap.appendChild(lockIcon);
    }
    button.appendChild(lockWrap);

    var labelNode = document.createElement('span');
    labelNode.className = 'cvf-049-ab__checkout-label';
    labelNode.textContent = label;
    button.appendChild(labelNode);
  }

  function ensureEncryptedLine(footer, config, hasItems) {
    var encrypted = footer.querySelector('.cvf-049-ab__encrypted');
    var checkoutWrap =
      footer.querySelector('.styles_Footer__checkoutButton__') ||
      footer.querySelector('.upcart-checkout-button-container');
    var express = getExpressPay(footer.closest('.upcart-cart') || document);

    if (!encrypted) {
      encrypted = document.createElement('div');
      encrypted.className = 'cvf-049-ab__encrypted';
      encrypted.setAttribute(MARK_ATTR, 'true');

      var iconWrap = document.createElement('span');
      iconWrap.className = 'cvf-049-ab__encrypted-icon';
      var icon = cloneIcon('cvf-049-ab-icon-encrypted');
      if (icon) iconWrap.appendChild(icon);

      var text = document.createElement('p');
      text.className = 'cvf-049-ab__encrypted-text';
      text.textContent = config.encryptedMessage;

      encrypted.appendChild(iconWrap);
      encrypted.appendChild(text);
    } else {
      var textNode = encrypted.querySelector('.cvf-049-ab__encrypted-text');
      if (textNode) textNode.textContent = config.encryptedMessage;
    }

    if (checkoutWrap && checkoutWrap.parentNode) {
      if (encrypted.previousElementSibling !== checkoutWrap) {
        checkoutWrap.insertAdjacentElement('afterend', encrypted);
      }
    } else if (express && express.parentNode) {
      express.parentNode.insertBefore(encrypted, express);
    } else if (!encrypted.parentNode) {
      footer.appendChild(encrypted);
    }

    if (hasItems) {
      encrypted.classList.add(VISIBLE_CLASS);
    } else {
      encrypted.classList.remove(VISIBLE_CLASS);
    }
  }

  function updateContinueShopping(cartRoot, config) {
    var link = getContinueLink(cartRoot);
    if (!link) return;

    if (link.getAttribute(MARK_ATTR) === 'true' && link.textContent === config.continueShopping) {
      return;
    }

    link.setAttribute(MARK_ATTR, 'true');
    link.textContent = config.continueShopping;
  }

  function applyVariant(cart) {
    if (applying) return;

    var cartRoot = getCartRoot();
    if (!cartRoot) return;

    applying = true;

    try {
      var config = getConfig();
      var hasItems = !!(cart && cart.item_count > 0);
      var footer = getFooter(cartRoot);

      updateCartCloseIcon(cartRoot);
      ensureTrustBadges(cartRoot, config);
      ensureFitmentBanner(cartRoot, config, hasItems);
      ensureInstallments(cartRoot, config, cart);

      if (footer) {
        ensureSummary(footer, config, cart);
        updateCheckoutButton(cartRoot, config, cart);
        ensureEncryptedLine(footer, config, hasItems);
      }

      updateContinueShopping(cartRoot, config);
    } finally {
      applying = false;
    }
  }

  function applyFromCache() {
    applyVariant(cachedCart);
  }

  var debouncedApplyFromCache = debounce(applyFromCache, 100);

  function startCartObserver() {
    if (cartObserverStarted) return;

    var cartRoot = getCartRoot();
    if (!cartRoot) return;

    cartObserverStarted = true;

    var observer = new MutationObserver(function () {
      if (applying) return;
      debouncedApplyFromCache();
    });

    observer.observe(cartRoot, { childList: true, subtree: true });
  }

  async function refresh() {
    var cart = await fetchCart();
    if (cart) cachedCart = cart;

    applyVariant(cachedCart);
    startCartObserver();
  }

  var debouncedRefresh = debounce(refresh, 150);

  function onCartDomChange() {
    requestAnimationFrame(function () {
      applyVariant(cachedCart);
    });
    debouncedRefresh();
  }

  function initUpCartListeners() {
    if (typeof window.upcartSubscribeCartLoaded !== 'function') {
      setTimeout(initUpCartListeners, 500);
      return;
    }

    window.upcartSubscribeCartLoaded(onCartDomChange);
    window.upcartSubscribeCartUpdated(onCartDomChange);
    window.upcartSubscribeCartOpened(onCartDomChange);
    window.upcartSubscribeAddedToCart(onCartDomChange);
  }

  window.cvf049AbRefresh = function () {
    refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpCartListeners);
  } else {
    initUpCartListeners();
  }

  refresh();
})();
